import * as React from 'react';
const CandidaIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-1{fill-rule:evenodd;stroke:${primaryColor ||
        '#282828'}}.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'}}`}</style>
    </defs>
    <path
      d="M60.06 139.03c-.61-2.88-1.21-5.98-1.81-9.5-5.96-35.18 4.93-41.62 12.38-68.56M139.94 139.03c.61-2.88 1.21-5.98 1.81-9.5 5.96-35.18-4.93-41.62-12.38-68.56M95.21 121.74c1.21 5.72 1.29 11.49.93 17.29M103.85 139.03c-.35-5.8-.27-11.58.93-17.29"
      className="prefix__cls-1"
    />
    <path
      d="M76.6 92.58c-4.59-1.91-9.43-4.35-14.69-7.3M138.09 85.28c-5.44 3.06-10.45 5.57-15.19 7.51M141.52 96.59c-15.91 4.77-29.56 13.67-36.75 25.15-1.07 1.67-2.98 2.29-4.78 2.3-1.8 0-3.71-.63-4.78-2.3-7.2-11.48-20.84-20.38-36.75-25.15"
      className="prefix__cls-1"
    />
    <path
      d="M113.49 91.16c0 7.51-6.09 13.61-13.61 13.61-4.44 0-8.69-2.23-11.21-5.89-3.09-4.48-2.51-9.97-.47-14.78 2.51-5.93 6.27-11.34 8.05-17.53 4.87 4.81 7.35 9.76 8.58 15.95.96-2.46 1.82-4.96 1.77-7.59 4.03 4.17 6.89 10.45 6.89 16.25Z"
      className="prefix__cls-2"
    />
    <path
      d="M94.89 101.73c-.63-1.68-.39-3.57.18-5.27.58-1.7 1.47-3.27 2.18-4.91s1.23-3.44 1-5.22c2.22 1.03 4.01 2.86 5.19 5 1.19 2.14 1.79 4.56 1.99 7 .13 1.59.04 3.32-.96 4.56-2.32 2.88-8.24 2.42-9.59-1.16Z"
      className="prefix__cls-2"
    />
  </svg>
);
export default CandidaIcon;
